import { render, staticRenderFns } from "./Seventy_percent.vue?vue&type=template&id=32498639&scoped=true"
import script from "./Seventy_percent.vue?vue&type=script&lang=js"
export * from "./Seventy_percent.vue?vue&type=script&lang=js"
import style0 from "./Seventy_percent.vue?vue&type=style&index=0&id=32498639&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32498639",
  null
  
)

export default component.exports